import React from 'react'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Date from 'components/Date'
import {dateTypes} from 'utils/enums/formula'

const Field = styled.div`
    margin: 30px 0 20px;
    display: flex;
    align-items: flex-end;
`

const Container = styled.div`
    box-sizing: border-box;
    height: 29px;
    align-items: center;
    position: relative;
    display: flex;
    margin-left: 30px;
    width: 100%;

    &:before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.42);
    }

    :hover {
        &:before {
            border-bottom: 2px solid #4a4a4a;
        }
    }
`

class DateFormula extends React.Component {
    handleChange = (event) => {
        this.props.handleUpdate(event.target.value, this.props.date)
    }

    handleChangeExactDate = (value) => {
        this.props.handleChangeExactDate(value, this.props.date)
    }

    render() {
        const { intl } = this.props

        return (
            <Field>
                <FormControl fullWidth variant="standard">
                    <InputLabel>{intl.formatMessage({id: this.props.label})}</InputLabel>
                    <Select
                        value={this.props.dateType === dateTypes.exact.code ? dateTypes.exact.code :
                            this.props.dateType === dateTypes.now.code ? dateTypes.now.code : this.props.value.join(',')}
                        onChange={this.handleChange}
                        inputProps={{
                            name: 'dateType'
                        }}
                    >
                        {Object.keys(dateTypes).map((item, index) =>
                            <MenuItem key={index} value={dateTypes[item].code}>
                                {intl.formatMessage({id: `config.formula_period_${dateTypes[item].label}`})}
                            </MenuItem>
                        )}
                        {this.props.fields.map((item, index) =>
                            <MenuItem key={index} value={item.id}>
                                {item.name}
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>
                {this.props.dateType === dateTypes.exact.code &&
                    <Container>
                        <Date
                            defaultValue={this.props.value}
                            handleUpdateValue={this.handleChangeExactDate}
                            padding='0px'
                        />
                    </Container>
                }
            </Field>
        )
    }
}

export default injectIntl(DateFormula)
